import React from "react";
import Header from "../Header/Header";
import "./Feedback.scss";

import { VStack, HStack } from "Components/LabIZO/Stackizo";
import { ColorX } from "static";
import { IGPTQADashboardState } from "../Dashboard";
import PieChartDistribution from "./PieChartDistribution/PieChartDistribution";

interface FeedbackProps {
  base: IGPTQADashboardState["base"];
  data: IGPTQADashboardState["data"];
}

const Feedback: React.FC<FeedbackProps> = ({ base, data }) => {
  let { titles, graphTitles } = base;

  return (
    <VStack width="100%">
      <Header title={(titles && titles.Feedback) || ""} />
      <HStack
        className="Feedback"
        width="100%"
        height="100%"
        style={{ boxShadow: "5px 5px 13px #ededed, 5px 5px 13px #ffffff", backgroundColor: ColorX.GetColorCSS("GraphBG"), borderRadius: "20px", overflow: "hidden" }}
      >
        <PieChartDistribution width="50%" title={graphTitles && graphTitles.DocQueryDistribution} data={data && data.Feedback.docQueryDistribution} className="doc-query-distribution" take={12} />
        <PieChartDistribution width="50%" title={graphTitles && graphTitles.LikeDistribution} data={data && data.Feedback.likeDistribution} className="like-distribution" />
      </HStack>
    </VStack>
  );
};
export default Feedback;
